module.exports = __webpack_public_path__ + "static/media/Niger.544b4f49.png";